import type { SymbolDefinition } from "../types.ts";

export const sensor: SymbolDefinition = {
  id: "ep-sensor",
  familyKey: "sensor",
  deviceKind: "sensor",
  version: "0.1.0",
  label: { sv: "Givare", en: "Sensor" },
  description: { sv: "Generell givare.", en: "Generic sensor." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <path d="M 6 18 L 12 4 L 18 18 Z"/>
      <line x1="12" y1="18" x2="12" y2="22"/>
    </g>
  `,
  terminals: [
    { id: "out", kind: "signal", label: "S", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "B",
  searchKeywords: ["givare", "sensor"],
};
